import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { VendedorService } from 'src/app/services/vendedor.service';
import * as _ from 'lodash'

@Component({
  selector: 'app-modal-seleccionar-vendedor',
  templateUrl: './modal-seleccionar-vendedor.component.html',
  styleUrls: ['./modal-seleccionar-vendedor.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionarVendedorComponent implements OnInit {

  // Input
  @Input() origen: String = null

  // Modales
  @ViewChild('seleccionarVendedor', { static: true })
  seleccionarVendedorModal: ModalDirective;

  // Form
  formData: FormGroup

  // Data
  private rutEmpresa: number
  private sucursalCodigo: number
  dataAll: Array<any> = null
  data: Array<any> = null
  dataSeleccionada: Array<any> = []
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false

  // Output
  @Output() onSelectSingle: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Input

  // Utils
  private log: any
  codigoVendedor: number;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private vendedorService: VendedorService,
    private rutService: RutService,
    private clog: ConsoleService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-VENDEDOR')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    this.createForm()
  }

  /********* FORM *********/
  private createForm() {
    this.formData = this.fb.group({
      codigo: [null, []],
      rut: [null, []],
    });
  }

  private cleanFormData() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.initializeFormData()
  }

  private initializeFormData() {
    this.formData.get("codigo").setValue(null)
    this.formData.get("rut").setValue(null)
  }

  private cleanResultData() {
    this.dataAll = null
    this.data = null
    this.loading = false
  }

  private cleanAll() {
    this.cleanFormData()
    this.cleanResultData()
  }
  /********* FORM *********/

  /********* SHOW/HIDE *********/
  show() {
    this.cleanAll()
    this.seleccionarVendedorModal.show();
  }

  hide() {
    this.formData.reset()
    this.seleccionarVendedorModal.hide();
  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  cleanInput() {
    this.formData.get('codigo').setValue(null)
    this.formData.get('rut').setValue(null)
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1

    // this.validateAllFormFields(this.formData);
    // if (!this.formData.valid) {
    //   return
    // }

    this.cleanResultData()

    this.dataAll = []
    this.data = []
    this.loading = true

    const inputParams = this.createInputParams()
    // this.executeQuery(inputParams, result => {
    //   this.renderQueryResults(result)
    // })
    this.vendedorService.obtenerSegunFiltro(inputParams, result => {
      this.renderQueryResults(result)
    })
  }

  private createInputParams() {
    let rut = 0
    if (this.formData.get('rut').value) {
      rut = this.rutService.Limpiar(this.formData.get('rut').value)
      rut = this.rutService.QuitarDV(rut)
    }

    return {
      entidad: {
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalCodigo),
        tipobusqueda: 1,
        codigo: Number(this.formData.get('codigo').value),
        rut
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
  }

  private renderQueryResults(result: QueryResult) {
    const { registros } = result
    this.dataAll = registros
    this.paginationContext.RecordsCount = this.dataAll.length //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas

    this.dataAll.map(vendedor => {
      vendedor.rutFormato = this.rutService.AgregarDV(vendedor.rut)
      vendedor.checked = false
      this.removeElementTypename(vendedor)
    })

    this.showPage(this.paginationContext.CurrentPage)
    this.loading = false
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.data = _.slice(this.dataAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }

  selectData(vendedor: any) {
    const _vendedor = { ...vendedor }
    delete _vendedor.rutFormato
    delete _vendedor.__typename
    this.lastRut = this.rutService.AgregarDV(_vendedor.rut)
    this.onSelectSingle.emit({
      data: _vendedor
    })

    this.hide()
  }

  /********* OPERATIONS *********/


  /********* OUTSIDE CALL *********/
  lastRut: string = ''
  // Método para ser consumido desde fuera del componente
  searchByRut(rutConDv: string) {

    if (!(this.lastRut !== rutConDv && rutConDv && rutConDv.length > 0 && rutConDv !== '0'))
      return
    this.lastRut = rutConDv
    let rut = 0
    rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutConDv))

    let inputParams = {}
    inputParams = {
      entidad: {
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalCodigo),
        tipobusqueda: 1,
        codigo: 0,
        rut
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.vendedorService.obtenerSegunFiltro(inputParams, (result) => {
      this.handleResultFromOutterSearch(result)
    })
  }

  public clearLast() {
    this.lastRut = ''
  }

  public setLast(value) {
    this.lastRut = value
  }

  private handleResultFromOutterSearch({ totalRegistros, registros }) {
    this.log('handleResultFromOutterSearch', totalRegistros, registros)
    if (totalRegistros === 1) {
      this.removeElementTypename(registros[0])
      this.selectData(registros[0])
    } else {
      this.notFound()
    }
  }

  private notFound() {
    this.onNotFound.emit()
  }
  /********* OUTSIDE CALL *********/

}
